import { Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import HomePage from "./pages/HomePage";

const AppRouter = () => {
  return (
    <ScrollToTop>
      <Routes>
        {/* Redirect root to Serbian by default */}
        <Route path="/" element={<Navigate to="/sr" replace />} />

        {/* Language-specific routes */}
        <Route path="/:lang" element={<HomePage />} />
        <Route path="/:lang/about-me" element={<HomePage />} />
        <Route path="/:lang/basic-rules" element={<HomePage />} />
        <Route path="/:lang/gallery" element={<HomePage />} />
        <Route path="/:lang/contact" element={<HomePage />} />

        {/* Catch-all route - redirect to Serbian */}
        <Route path="*" element={<Navigate to="/sr" replace />} />
      </Routes>
    </ScrollToTop>
  );
};

export default AppRouter;
